module.exports = __webpack_public_path__ + "img/OU.e5097f7f.jpg";